module.exports = __webpack_public_path__ + "static/media/sum_draft_plan.9a1e8ac3.png";